import CommonStyles from "../../styles/CommonStyles.css";

export const styles = (theme) => ({
  ...CommonStyles,
  root: {
    backgroundColor: "#303030 !important",
     fontSize:"1em",
    fontWeight: "normal",
    boxShadow: "none",
    
    "& ul": {
      padding: "0",
    },
    "& div": {
      background: "none",
    },
    "& a": {
      padding: "10px 15px",
       fontSize:"0.8em",
      background: "none",
      borderLeft: "3px solid transparent",
    },
    "& a:hover": {
      color: "#fff",
      background: "rgba(0, 0, 0, .1)",
    },
    
    "& hr": {
      background: "rgb(72 72 72)",
      margin: " 0",
      padding: " 0",
      height: "1px",
      border: "none",
    },
  },
  activeLink: {
    borderLeft: "3px solid #60E99B !important",
    fontWeight: "400",
    background: "#252525",
    padding: "6px 15px 6px 20px",
    color: "#60E99B",
    "&:hover .MuiListItemIcon-root":{
      color: "#fff",
      "& path":{
        color: "#fff",
        stroke: "#fff",
      }
    },
    "& .MuiListItemIcon-root":{
      color: "#60E99B",
      "& path":{
        color: "#60E99B",
        stroke: "#60E99B",
      }
    }
  },
  version: {
    fontSize: "0.7em",
    display: "block",
    textAlign: "center",
    padding: "10px",
    color: "#a9a9a9",
  },
  navList: {
    "& > li:hover": {
      background: "rgba(0, 0, 0, .1)",
    },
  },
  postplay: {
    padding: "0px 4px",
    "& button": {
      color: "#00d056",
      borderRadius: "inherit",
    },
    "& button:hover": {
      color: "#00d056",
      background: "none",
      borderRadius: "inherit",
    },
    "& button:active": {
      color: "#00d056",
      background: "none",
      borderRadius: "inherit",
    },
    "& svg": {
      color: "#00d056",
      borderRadius: "inherit",
    },
  },
  IconName: {
    minWidth: "32px",
    color:"#fff",
    fontSize:"1.3em",
    "& path":{
      color:"#fff",
      stroke:"#fff"
    }
  },
  iconSize:{
    fontSize:"18px",
  },

  newIcons:{
    fontSize:"16px",
    marginRight:"10px",
    width: "21px",
    "& path":{
      stroke:"#fff"
    },
  },
  newSubIcons:{
    fontSize:"27px",
    marginRight:"10px",
    width: "21px",
    height: "21px",
  },
  navLongNameBreak:{
    wordBreak: "break-word",
    paddingRight: "20px",
    whiteSpace:" break-spaces",
  },
  removeStroke:{
    "& path":{
      stroke:"transparent",
    }
    
  }
});
